import { getPriceFormatted as getPriceFormattedRocket, defaultPriceOptions } from '@i22team/rocket';
import type { Options } from '@i22team/rocket/dist/price-utils';
import { getRebatePercentage, getRebatePrices } from '~/lib/rebate-helper';
import type { Rebate } from '~/stores/offers';
import type {
  PaymentFrequency,
  PriceType,
  Price,
  Maybe,
} from '#shared/types/goliath/goliath.types';

function getPricesFromOfferWithRebate(
  offer: Offer | ListOffer | OfferWithProduct,
  rebate: Rebate,
  quantity = 1
): Price[] | undefined {
  if (!rebate?.staggereds || !offer.prices) {
    return offer.prices?.filter((p) => p !== null);
  }

  const rebatePercentage = getRebatePercentage(rebate.staggereds, quantity);

  return getRebatePrices(offer.prices as Price[], rebatePercentage);
}

function getPriceFormatted(
  prices: (Price | Maybe<Price>)[],
  type: PriceType | 'DEFAULT' | 'WAS',
  paymentFrequency: PaymentFrequency | 'ONETIME' | 'MONTHLY' = 'ONETIME',
  options: Options = defaultPriceOptions
) {
  return getPriceFormattedRocket(prices, type, paymentFrequency, options);
}

function getPriceFromOfferFormatted(
  offer: Offer | ListOffer,
  type: PriceType | 'DEFAULT' | 'WAS',
  paymentFrequency: PaymentFrequency | 'ONETIME' | 'MONTHLY' = 'ONETIME',
  options: Options = defaultPriceOptions
) {
  if (!offer.prices) return undefined;
  return getPriceFormatted(offer.prices, type, paymentFrequency, options);
}

export { getPricesFromOfferWithRebate, getPriceFormatted, getPriceFromOfferFormatted };
